import React from 'react'
import styles from './ThankyouPopup.module.css'
import thankyou from '../Asset_Products/thankyouImage.svg'
const ThankyouPopup = ({ onClose }) => {
    return (
        <div className={`${styles.thankyouPopup}`}>
            <div className={`${styles.thankyou}`}>
                <div className={`${styles.thankyouPopupHeadings}`}>
                    <p className={`${styles.thankyouPopupHeading}`}>Thank you for your interest !!</p>
                    <p className={`${styles.thankyouPopupHeading2}`}>We’ll get back to you soon</p>
                </div>
                <div className={`row justify-content-center ${styles.thankyouRow}`}>

                    <div className={`col-12 col-md-5 ${styles.thankyouContent}`}>
                        <p className={`${styles.thankyouparagraph}`}>
                            We're really glad you're considering us for your insurance needs. One of our friendly team members will give you a call soon to help you out. We appreciate your trust in Policy Planner and look forward to chatting with you!
                        </p>
                        <button className={`${styles.TakMeBackBtn}`} onClick={onClose}>Great! Take Me Back</button>
                    </div>
                    <div className={`col-12 col-md-7 ${styles.thankyouImg}`}>
                        <img className={`${styles.thankyouImage}`} src={thankyou} alt="img" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ThankyouPopup
